import React, { Component } from 'react';
import _ from 'lodash';

class GroupDataForm extends Component {
	constructor(props){
		super(props)

		this.handleChange = this.handleChange.bind(this);
	}

	handleChange(){
		var group = _.clone(this.props.group);
		group.code = this.refs.code.value;
		group.name = this.refs.name.value;
		this.props.handleChangeData(group);
	}

	render() {
		return (
			<div>
				<div className='row form-group'>

					<div className='col-md-12'>
						<div className='row form-group'>
							<div className='col-md-12'>
								<label className='field-label required'><strong>Code</strong></label>
							</div>
							<div className='col-md-12'>
								<input 
									type='text' 
									ref='code' 
									value={this.props.group.code}
									className='form-control' 
									placeholder='Code...'
									onChange={this.handleChange}/>
							</div>
						</div>
					</div>

					<div className='col-md-12'>
						<div className='row form-group'>
							<div className='col-md-12'>
								<label className='field-label required'><strong>Name</strong></label>
							</div>
							<div className='col-md-12'>
								<input
									type='text' 
									ref='name' 
									value={this.props.group.name}
									className='form-control' 
									placeholder='Name...'
									onChange={this.handleChange}/>
							</div>
						</div>
					</div>

				</div>
			</div>
		)
	}
}

export default GroupDataForm;


// WEBPACK FOOTER //
// ./src/components/manage_users/businesses/GroupDataForm.js